import React from 'react';
import { Box, ToggleCard, Paragraph } from '@zillow/constellation';

var Tile = function Tile(_ref) {
  var href = _ref.href,
    Icon = _ref.Icon,
    IconOutline = _ref.IconOutline,
    _onClick = _ref.onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    title = _ref.title;
  var RenderedIcon = selected ? Icon : IconOutline;
  return /*#__PURE__*/React.createElement(Box, {
    as: ToggleCard,
    padding: {
      default: 'sm',
      md: 'lg'
    },
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 || _onClick();
    },
    pressed: selected,
    cardType: "secondary",
    sx: {
      position: 'relative'
    }
  }, href ? /*#__PURE__*/React.createElement(Box, {
    as: "a",
    href: href,
    target: target,
    sx: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0
    }
  }) : null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(RenderedIcon, {
    size: "lg",
    marginBottom: "xs"
  }), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: selected ? {
      default: 'finePrintHeading',
      md: 'bodyHeading'
    } : {
      default: 'finePrint',
      md: 'body'
    },
    textAlign: "center"
  }, title)));
};
var Tile$1 = Tile;

export { Tile$1 as default };
